import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import TierCard from "../component/TierCard";
import awardSymbol from "../assets/images/awardSymbol.png";
import awardCup from "../assets/images/cup.png";
import UserProfileCard from "../component/UserProfileCard";
import PageTitle from "../component/PageTitle";
import { Link, useNavigate } from "react-router-dom";
import GameBanner from "../assets/images/gamebanner.png";
import FirstGame from "../assets/images/game1.png";
import SecondGame from "../assets/images/g2.png";
import ThirdGame from "../assets/images/g3.png";
import FourthGame from "../assets/images/g4.png";
import RewardsBox from "../assets/images/rewardsBox.png";
import Carousal from "../component/Carousal";
import FirstItem from "../assets/images/item.png";
import FirstEGVItem from "../assets/images/egv1.png";
import SecondEGVItem from "../assets/images/egv2.png";
import ColorCalender from "../assets/images/calendar.png";
import LocationPin from "../assets/images/map-pin.png";
import ProductService from "../services/Product";
import DefaultImage from "../assets/images/logo-small.png";
import ProfilePic from "../assets/images/profilePicDefault.png";
import EventCard from "../component/EventCard";
import Loader from "../component/Loader";
import OtherService from "../services/Other";
import newsDefaultImage from "../assets/images/newsDefault.png";
import AmbujaLogo from "../assets/images/ambujaLogo.png";
import AccLogo from "../assets/images/accLogo.png";
import AdaniLogo from "../assets/images/adaniLogo.png";
import DatePicker from "../component/DatePicker";
import { useDispatch, useSelector } from "react-redux";
import FadeInSection from "../component/FadeInSection";
import useScrollToTop from "../hooks/useScrollToTop";
import { API_IMAGE_BASE_URL } from "../constants/common";
import VideoModal from "../component/Modals/VideoModal";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { addUserPersona } from "../redux/slices/currentUserSlice";
import { addIsApproved } from "../redux/slices/userTypeSlice";
import { addTierPerformance } from "../redux/slices/tierPerformanceSlice";
import { addUserPoints } from "../redux/slices/userPointsSlice";
import Performance from "../component/Dashboard/Performance";
import PerformanceTrends from "../component/Dashboard/PerformanceTrends";
import ApprovalAnalytics from "../component/Dashboard/ApprovalAnalytics";
import TseContractorOverview from "../component/Dashboard/TseContractorOverview";
import ContractorCountStatus from "../component/Dashboard/ContractorCountStatus";
import ProductWiseLift from "../component/Dashboard/ProductWiseLift";
import ServiceWiseLift from "../component/Dashboard/ServiceWiseLift";
import RecentTransactions from "../component/Dashboard/RecentTransactions";
// import ProfileInfo from "../component/Dashboard/ProfileInfo";
import ProgressBar from "../component/Dashboard/ProgressBar";
// import ContractorOverview from "../component/Dashboard/ContractorOverview";
import SummaryBoard from "../component/Dashboard/SummaryBoard";
import ContractorOverview from "../component/Dashboard/ContractorOverview";
import PerformaceTrackerDealer from "../component/Dashboard/PerformaceTrackerDealer";
import DealerGraph from "../component/Dashboard/DealerGraph";
import ZoneLocation from "../component/Dashboard/ZoneLocation";
import DealerOverview from "../component/Dashboard/DealerOverview";
import ReferralListComp from "../component/Dashboard/ReferralListComp";

const Landing = () => {
  useScrollToTop();
  const dispatch = useDispatch();
  const currentBrand = useSelector((state) => state.userTypeSlice.currentBrand);
  const tokens = useSelector((state) => state.userTypeSlice.token);
  const totalCartItems = useSelector((state) => state.countSlice.cartCount);
  const userData =  useSelector(
      state => state.userTypeSlice.userData,
  );
  const personalInfoResponse = useSelector(
    (state) => state.userTypeSlice.personalInfoResponse
  );
  const isProductCategory = useSelector(
    (state) => state.userTypeSlice.productCategory
  );
  //Format Date
  const formatDate = (date) => {
    const dateTime = new Date(date);
    return dateTime.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
  };
  //All useStates
  const navigate = useNavigate();
  //Loader
  const [loading, setLoading] = useState(true);
  const [loadingHomeSlider, setLoadingHomeSlider] = useState(true);
  const [isBanner, setIsBanner] = useState([]);
  const [userType, setUserType] = useState("");
  //Event List
  const [isEventListAll, setIsEventListAll] = useState([]);
  const [isEventListData, setIsEventListData] = useState(false);
  //EGV List
  const [isEgvList, setIsEgvList] = useState([]);
  const [isEgvListData, setIsEgvListData] = useState([]);
  const [isUserData, setIsUserData] = useState("");
  const [isPointInfo, setIsPointInfo] = useState("");
  const [isDateInfo, setIsDateInfo] = useState("");
  //Banner Data
  const [userInfo, setUserInfo] = useState(null);
  const [pointDetails, setPointDetails] = useState(null);
  const [isUserAllInfo, setUserAllInfo] = useState();
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedBannerItem, setSelectedBannerItem] = useState({ id: "",
    image: "",
    video: "",
    source: "",
    alt_text: ""})
    const [count, setCount] = useState(0);

    const [options, setOptions] = useState({
      title: {
        text: 'My Performance'
      },
      series: [{
        data: [0]
      }],
      xAxis: {
        categories: [],
      },
      chart: {
        height: 250,
        borderRadius: 5

    }
    })

  //Mobile Sap Checking
  const isContractor = true;
  //Landing Banner

  useEffect(() => {
    let loginUser = JSON.parse(localStorage.getItem('userData'))?.description;
    setUserType(loginUser)
    const BannerFetch = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const BannerDataResponse = await ProductService.bannerDashboard();
        setLoadingHomeSlider(false);
        if (!BannerDataResponse.error) {
          const rewardsBanner =
            BannerDataResponse.data.content_banner_details_contact
              .content_spot_banners;
          const banners = rewardsBanner.map((item) => ({
            id: item.banner_id,
            image: API_IMAGE_BASE_URL+item.file_path,
            video: item.target_link,  
            source: "uri",
            alt_text: item?.alt_text,
            targetLink: item.target_link
          }));

          if (banners.length > 0) {
            setIsBanner(banners);
          } else {
            setIsBanner([
              { image: require("./../assets/images/full-banner.png") },
            ]);
          }
          // setLoadingBanner(false)
        }

        // if (!BannerDataResponse.error) {
        //   setIsBanner(
        //     BannerDataResponse?.data?.content_banner_details_contact
        //       ?.content_spot_banners
        //   );
        //   setLoadingHomeSlider(false);
        // } else {
        //   setIsBannerData(false);
        //   setLoadingHomeSlider(false);
        // }
      } catch (error) {
        console.error("Banner Data");
      }
    };

    setTimeout(() => {
      BannerFetch();
    }, 800);
  }, [tokens]);

  //UseEffect
  useEffect(() => {
    //User Details
    const userInfo = JSON.parse(localStorage.getItem("userData"));
    setIsUserData(userInfo);
  }, [tokens]);

  useEffect(() => {
    if (isProductCategory.length > 0) {
      setLoading(false);
    }
  }, [isProductCategory]);

  //Tier Card - derived from profile data already fetched in TopBar
  useEffect(() => {
    if (!personalInfoResponse?.response?.message) return;
    dispatch(
      addIsApproved({
        isApproved:
          personalInfoResponse.response.message.is_approved == "true",
      })
    );
    setIsPointInfo(personalInfoResponse.response.message);
    const dateTime = new Date(
      personalInfoResponse.response.message.enrollment_date
    );
    const formattedDateTime = dateTime.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    setIsDateInfo(formattedDateTime);
    setLoading(false);
  }, [personalInfoResponse]);

  //Upcoming Events
  useEffect(() => {
    getDataList()
    const upComingEventsFetch = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const userInfo = JSON.parse(localStorage.getItem("userData"));
        const hierarchyId = userInfo.dcm_hierarchies_id;
        const upComingEventsResponse =
          await OtherService.eventListByHierarchyId(hierarchyId);
        if (
          !upComingEventsResponse.error &&
          upComingEventsResponse.data.data.length > 0
        ) {
          setIsEventListAll(upComingEventsResponse.data.data);
          setLoading(false);
        } else {
          setLoading(false);
          setIsEventListData(true);
        }
      } catch (error) {
        console.error("upComing Events Fetch");
      }
    };
    upComingEventsFetch();
  }, [tokens]);
  //Profile Image
  useEffect(() => {
    if (tokens.access) {
      OtherService.myPointsNew()
        .then((res) => {
          if (res.success) {
            setPointDetails(res.response.pointDetails);
            dispatch(addUserPoints(res.response.pointDetails));
          }
        })
        .catch((err) => {
        });
    }
    const userInfo = JSON.parse(localStorage.getItem("userData"));
    dispatch(addUserPersona({ userPersona: userInfo.description }));
    setUserInfo(userInfo);
  }, [tokens]);

  //Profile Info - derived from profile data already fetched in TopBar
  useEffect(() => {
    if (!personalInfoResponse?.response?.message) return;
    setUserAllInfo(personalInfoResponse.response.message);
    setLoading(false);
  }, [personalInfoResponse]);
  //EGV
  useEffect(() => {
    const EGVFetch = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const EGVResponse = await OtherService.egvList(token);
        if (EGVResponse.response_code == 200 && EGVResponse.data.length > 0) {
          setIsEgvList(
            EGVResponse.data?.map((item, key) => {
              const imageUrl = item.image;
              const parts = imageUrl.split("/");
              const lastElement = parts[parts.length - 1];
              return {
                id: item.id,
                title: item.title,
                description: item.title,
                image: lastElement ? DefaultImage : item.image,
              };
            })
          );
          setLoading(false);
          setIsEgvListData(false);
        } else {
          setLoading(false);
          setIsEgvListData(true);
        }
      } catch (error) {
        console.error("EGVFetch");
      }
    };
    EGVFetch();
  }, [tokens]);

  function getDataList() {
    setLoading(true);

    //'2023-03-01','2024-01-01'
    OtherService.getTierPerfomance()
      .then(res => {
        if (res.statusCode == 401) {
          // logoutHandler();
          // dispatch(addShouldLogout({shouldLogout: true}));
        }

        dispatch(addTierPerformance({ tierPerformance: res }));

        if (res.success == true) {
          // const result = res?.response?.data;
          // // if (result) {
          // const ending_slab = result?.ending_slab;
          // const point =
          //   result && result?.totalRewardsPoints
          //     ? result?.totalRewardsPoints
          //     : result && result?.totalSale
          //     ? result?.totalSale
          //     : 0;
          // const percentage = (parseInt(point) / parseInt(ending_slab)) * 100;
          // settierPercent(percentage);
          // }
          // const other_tierlist = res?.response?.data?.other_Tiers;
          // // )
          // setother_Tiers(other_tierlist);

          // const graphData = res.response.data.graphData;
          // const new_arr = [];

          const format_data = res?.response?.data?.sales.map(
            (element, index) => {
              return Number(element?.totalSales);
              // return {
              //   value: Number(element?.totalSales),
              //   label: String(element?.month_name.substring(0, 3)),
              //   dataPointText: String(element?.totalSales),
              //   // label: element.monthName,
              //   labelTextStyle: {color: '#222'},
              //   // frontColor: '#EDB3E6',
              //   // dataPointText: element.tierName,
              // };
            },
          );
          const xAxis = res?.response?.data?.sales.map(
            (element, index) => {
              return String(element?.month_name.substring(0, 3));
            },
          );
          // setDealerTierName(res?.response?.data?.tierDetails[0]?.tier_name);
          if (format_data.length > 0) {
            setOptions(p=> ({
              ...p,
              title: {
                text: 'My Performance'
              },
              series: [{
                data: [...format_data]
              }],
              xAxis: {
                categories: xAxis
              }
            }))
            // setchartData([...format_data]);
          }

          setLoading(false);
        } else {
          // setallData([]);
          setLoading(false);
        }
      })
      .catch(err => {
        // setallData([]);
        setLoading(false);
        console.error(JSON.stringify('tier performance error'));
      });
  }
  const handleShowProduct = (catgryId) => {
    if(userData?.document_exist == '1') {
      navigate(`/rewards-category-list/${catgryId}`);
    } else {
      navigate('/dynamic-ekyc', { state: catgryId })
    }
  };
  //Event Read More
  const handleEventReadMore = (eventId) => {
    navigate(`/hierarchyEventList/${eventId}`);
  };

  function bannerHandler(item) {
    if(item.targetLink) {
      navigate(`/${item.targetLink}`);
      return;
    }
    if(item.alt_text == "video") {
      setShowVideoModal(true)
      setSelectedBannerItem(item)
    }
  }
  return (
    <>
      {/* {loading && <Loader />} */}

      {/* <Header /> */}
      {/* Banner Section */}
      <div className="hmTopBannerSection ad-banner">
        <FadeInSection>
          <Container fluid>
            <Row>
              <Col xs={12} lg={7} className="flexCol">
                {loadingHomeSlider && <Loader loader="smallScreen" />}
                <Carousel>
                  {isBanner?.map((item, index) => {
                    const { image, content_map_id } = item;
                    return (
                      <Carousel.Item key={index} onClick={() => bannerHandler(item)}>
                        <img
                          src={image}
                          alt="image"
                          className="img-fuid-hm-banner"
                        />
                      </Carousel.Item>
                    );
                  })}
                </Carousel>
              </Col>
              <Col xs={12} lg={5} className="left-pad-0 flexCol">
                <Row>
                  <Col xs={12} md={6} lg={12}>
                    <div
                      className={`profileCardBox ${
                        isUserData?.dcm_brands_id == 1
                          ? "profileCardBoxACC"
                          : isUserData?.dcm_brands_id == 2
                          ? "profileCardBoxAmbuja"
                          : isUserData?.dcm_brands_id == null || " "
                          ? "profileCardBoxAdani"
                          : ""
                      }`}
                    >
                      <UserProfileCard
                        mobileNo={isUserData.username}
                        // uhid={isUserAllInfo?.insuranceData.policy_number}
                        enrollmentDate={isDateInfo}
                        policyExpiryDate={formatDate(
                          // isUserAllInfo?.insuranceData.valid_till
                        )}
                        userName={isUserAllInfo?.full_name}
                        userDesignation={isUserData?.title}
                        companyLogo={
                          currentBrand?.id == 1
                            ? AccLogo
                            : currentBrand?.id == 2
                            ? AmbujaLogo
                            : currentBrand?.id == (null || " ")
                            ? AdaniLogo
                            : null
                        }
                        isContractor={isContractor}
                        profilePic={
                          isUserAllInfo?.profile_pic == null || ""
                            ? ProfilePic
                            : isUserAllInfo?.profile_pic
                        }
                        profilePercentage={isUserAllInfo?.profileCompletion}
                      />
                    </div>
                  </Col>

                  <Col xs={12} md={6} lg={12}>
                  {userInfo?.description !== "Contractor" && userInfo?.description !== "TSE" && (
                    (userInfo?.description !== "Dealer" &&
                      userInfo?.description !== "Retailer" &&
                        userInfo?.description !== "ARS") ? (
                          <div className="tierCardBox">
                             <TierCard
                                tierStar={awardSymbol}
                                awardCup={awardCup}
                                totalPoints={pointDetails?.total_points_redeem}
                                redemPoints={pointDetails?.points_reedemed}
                                availablePoints={pointDetails?.available_points}
                                tierName={isUserAllInfo?.tierName}
                              />
                          </div>
                    ) : (
                         <div className="high-charts-graph">
                            <HighchartsReact
                              highcharts={Highcharts}
                              options={options}
                            />
                          </div>
                       )
                  )}
                  
                  {/* {(userInfo?.description != "Dealer" && userInfo?.description != "Retailer" && userInfo?.description != "ARS") ? <div className="tierCardBox">
                      <TierCard
                        tierStar={awardSymbol}
                        awardCup={awardCup}
                        totalPoints={pointDetails?.total_points_redeem}
                        redemPoints={pointDetails?.points_reedemed}
                        availablePoints={pointDetails?.available_points}
                        // nextTarget={isPointInfo.availablePoints}
                        tierName={isUserAllInfo?.tierName}
                      /></div> : <div className="high-charts-graph">
                         <HighchartsReact
                            highcharts={Highcharts}
                            options={options}                            
                          />
                        </div>} */}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </FadeInSection>
      </div>

      {/* Popular Category */}
      {userType != 'TSE' && isProductCategory.length > 0 && <FadeInSection>
        <section className="padTop20 padd-after-baner">
          <Container>
            <Row>
              <Col xs={12}>
                <div className="pgTitleBlock">
                  <div>
                    <PageTitle blockTitle="Popular Category" />
                  </div>
                  <div className="vw-link">
                    <Link to="/rewards-category-list">View All</Link>
                  </div>
                </div>
              </Col>
              <Col xs={12}>
                <div className="categoryList">
                  <ul>
                    {isProductCategory?.slice(0, 4).map((item) => {
                      const { catgryName, id, catgryImg, catgryId } = item;
                      return (
                        <div key={id} className="categoryListitem">
                          <li
                            onClick={() => {
                              handleShowProduct(catgryId);
                            }}
                          >
                            <Link>
                              <div className="categoryListBoxWrap">
                                <div className="categoryListBox">
                                  {catgryImg !== null ? (
                                    <img src={catgryImg} alt="categoryImage" />
                                  ) : (
                                    <img
                                      src={DefaultImage}
                                      alt="categoryImage"
                                    />
                                  )}
                                </div>
                              </div>
                              <p>{catgryName}</p>
                            </Link>
                          </li>
                        </div>
                      );
                    })}
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </FadeInSection>}

      {userType === 'TSE' && (
  <FadeInSection>
    <section className="padTop20 padd-after-baner full-width-section">
      <div className="bigBoxGrid">
        <div className="gridItem">
          <Performance setCount={setCount}/>
        </div>
        <div className="gridItem">
          <PerformanceTrends />
        </div>
        <div className="gridItem">
          <ApprovalAnalytics />
        </div>
        <div className="gridItem">
          <TseContractorOverview />
        </div>
        <div className="gridItem">
          <ProductWiseLift />
        </div>
        <div className="gridItem">
          <ServiceWiseLift />
        </div>
        <div className="gridItem">
          <ContractorCountStatus count={count}/>
        </div>
      </div>
    </section>
  </FadeInSection>
      )}

      {userType === 'Contractor' && (
  <FadeInSection>
    <section className="padTop20 padd-after-baner full-width-section">
      <div className="bigBoxGrid">
        <div className="gridItem">
          <ProgressBar />
        </div>
        <div className="gridItem" style={{padding:0}}>
          <SummaryBoard />
        </div>
        <div className="gridItem">
          <ProductWiseLift />
        </div>
        <div className="gridItem">
          <ServiceWiseLift />
        </div>
        <div className="gridItem">
          <RecentTransactions />
        </div>
        {/* <div className="gridItem">
          <ReferralListComp />
        </div> */}
        <div className="gridItem">
          <ZoneLocation />
        </div>
      </div>
    </section>
  </FadeInSection>
)}

{userType === 'Dealer' && (
  <FadeInSection>
    <section className="padTop20 padd-after-baner full-width-section">
      <div className="bigBoxGrid">
        <div className="gridItem">
          <ContractorOverview />
        </div>
        <div className="gridItem" style={{padding:0}}>
          <SummaryBoard />
        </div>
        <div className="gridItem">
          <PerformaceTrackerDealer />
        </div>
        <div className="gridItem">
          <DealerOverview />
        </div>
        <div className="gridItem">
          <ProductWiseLift />
        </div>
        <div className="gridItem">
          <ZoneLocation />
        </div>
      </div>
    </section>
  </FadeInSection>
      )}

      {/* Play Games & Win Points */}
      {/* <FadeInSection>
        <section className="padTop50">
          <Container>
            <Row>
              <Col xs={12}>
                <PageTitle blockTitle="Play Game & Win Points" />
              </Col>
              <Col xs={12} lg={6}>
                <div className="gameBigBanner">
                  <img src={GameBanner} alt="gameBanner" className="img-fluid" />
                </div>
              </Col>
              <Col xs={12} lg={6} className="mt-0">
                <ul className="hmGameList">
                  <li>
                    <Link>
                      <div className="gameBox">
                        <img src={FirstGame} alt="game" className="img-fluid" />
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link>
                      <div className="gameBox">
                        <img src={SecondGame} alt="game" className="img-fluid" />
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link>
                      <div className="gameBox">
                        <img src={ThirdGame} alt="game" className="img-fluid" />
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link>
                      <div className="gameBox">
                        <img src={FourthGame} alt="game" className="img-fluid" />
                      </div>
                    </Link>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </section>
      </FadeInSection> */}
      {/* Rewards Connect Steps */}
      <FadeInSection>
        <section className="padTop50">
          <div className="purpleBg">
            <Container>
              <Row>
                <Col xs={12} lg={7}>
                  <div className="rewardsConnectSteps">
                    <p>
                      How To Get <b>Unlimited Rewards</b>{" "}
                      <span className="d-block">
                        Within <b>Few Clicks</b>
                      </span>
                    </p>

                    <div className="pt-4 whiteTxtParagraph">
                      There are many variations of passages available but the
                      majority have suffered alteration in some form going to
                      use a passage by injected humour randomised words which
                      don't look even slightly believable.
                    </div>

                    <div className="rewardsBoxImg">
                      <img
                        src={RewardsBox}
                        alt="rewardsBox"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={12} lg={5}>
                  <Row className="justify-content-center align-items-center h-100 mtt-30">
                    <Col xs={12} md={3} lg={6}>
                      <div className="choosenItem">
                        <span className="chooseCount">01</span>
                        <div className="chooseItemInfo">
                          <h3>Register yourself</h3>
                          <p>
                            There are many variations of the passages available
                            but the majo have suffered fact that reader will be
                            dist alteration.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} md={3} lg={6}>
                      <div className="choosenItem topFloat">
                        <span className="chooseCount">02</span>
                        <div className="chooseItemInfo">
                          <h3>Earn Rewards</h3>
                          <p>
                            There are many variations of the passages available
                            but the majo have suffered fact that reader will be
                            dist alteration.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} md={3} lg={6}>
                      <div className="choosenItem choosenItem-3">
                        <span className="chooseCount">03</span>
                        <div className="chooseItemInfo">
                          <h3>Browse Rewards</h3>
                          <p>
                            There are many variations of the passages available
                            but the majo have suffered fact that reader will be
                            dist alteration.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} md={3} lg={6}>
                      <div className="choosenItem topFloat choosenItem-4">
                        <span className="chooseCount">04</span>
                        <div className="chooseItemInfo">
                          <h3>Get Unlimited Rewards</h3>
                          <p>
                            There are many variations of the passages available
                            but the majo have suffered fact that reader will be
                            dist alteration.
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
        </section>
      </FadeInSection>
      {/* Featured Products */}
      {/* <section className='padTop50'>
        <Container>
          <Row>
            <Col>
              <PageTitle blockTitle='Featured Products' />
            </Col>
            <Col>
              <Carousal item={featuredItem}
              />

            </Col>
          </Row>
        </Container>
      </section> */}
      {/* EGV */}
      {/* <FadeInSection>
        <section className="padTop50 egvWrap">
          <Container>
            <Row>
              <Col xs={12}>
                <PageTitle blockTitle="Exclusive EGV" />
              </Col>
              {isEgvListData && (
                <Col xs={12} className="mb-4">
                  <div className="noDataMsg text-left">No data found!</div>
                </Col>
              )}
              {!isEgvListData && (
                <Col xs={12}>
                  <Carousal item={isEgvList} />
                </Col>
              )}
            </Row>
          </Container>
        </section>
      </FadeInSection> */}
      {/* NewsLetter */}
      {/* <FadeInSection>
        <section>
          <div className="newsLetterBg">
            <Container>
              <Row>
                <Col>
                  <div className="newsLetterBlock--">
                    <div className="newsFirstText">
                      Mauris suscipit enim non ligula lacinia
                    </div>
                    <div className="subscribeBox-- d-flex">
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Cras vitae lorem mauris. Fusce eu viverra dolor. In nisl
                        nunc, suscipit eget mauris ut, semper faucibus felis.
                        Praesent malesuada, nibh eu consequat bibendum, lectus
                        velit porta ante, vitae congue orci dolor sed orci. Nullam
                        id aliquam mi. Nullam volutpat erat ut metus consequat
                        efficitur. Ut aliquet vulputate eros, eu ultrices justo
                        placerat vitae. Duis tempus nec risus nec viverra. Nullam
                        varius iaculis ultrices. Morbi ipsum orci, condimentum ac
                        nunc in, volutpat pellentesque neque.
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </section>
      </FadeInSection> */}
      {/* Upcoming Events */}
      {/* <FadeInSection>
        <section className="padTop50 ad-Events-bx">
          <Container>
            <Row>
              <Col xs={12}>
                <PageTitle blockTitle="Upcoming Events" />
              </Col>
              {isEventListData && (
                <Col xs={12}>
                  <div className="noDataMsg">No data found!</div>
                </Col>
              )}
              {!isEventListData && (
                <Col xs={12}>
                  <Row>
                    {isEventListAll
                      ?.filter((item) => {
                        // const endDate = new Date(formatDate(item.eventEndDate));
                        const endDate = new Date(item.eventEndDate);
                        const today = new Date(); // Today's date
                        return endDate >= today;
                      })
                      .slice(0, 4)
                      .map((item, index) => {
                        const startDate = formatDate(item.eventStartDate);
                        const endDate = formatDate(item.eventEndDate);

                        return (
                          <Col xs={12} md={4} lg={3} key={index}>
                            <EventCard
                              image={
                                item?.contentFilesThumbnailImage == null
                                  ? newsDefaultImage
                                  : item.contentFilesThumbnailImage
                              }
                              calenderImage={ColorCalender}
                              eventTitle={item?.eventName}
                              locationPin={LocationPin}
                              eventPlace={item?.stateName}
                              eventDesc={item?.eventDesc}
                              eventType={item?.eventType}
                              eventStartTime={startDate}
                              eventEndTime={endDate}
                              onClickViewDetails={() => {
                                handleEventReadMore(item.eventId);
                              }}
                            />
                          </Col>
                        );
                      })}
                    {!isEventListAll?.some((item) => {
                      const endDate = new Date(item.eventEndDate);
                      const today = new Date(); // Today's date
                      return endDate >= today;
                    }) && (
                      <div className="error-message">No Upcoming Event Found</div>
                    )}
                  </Row>
                </Col>
              )}
            </Row>
          </Container>
        </section>
      </FadeInSection> */}
      <VideoModal open={showVideoModal} setOpen={setShowVideoModal} link={selectedBannerItem.video} />
    </>
  );
};

export default Landing;
